import { MembershipTypes } from '../../../../general/js/utils';
import { domainConstants } from '../../../sso/components/utils/constants/domain-constants';

export const TO_NON_TICKET = 'TO-Non-Ticket';
export const TO_TICKET = 'TO-Ticket';
export const WO_NON_TICKET = 'WO-Non-Ticket';
export const WO_TICKET = 'WO-Ticket';

export const TICKETS_DATA = 'ticketsData';

export const domainTicketsConstants = {
    [domainConstants.theOpen]: [TO_NON_TICKET, TO_TICKET],
    [domainConstants.womensOpen]: [WO_NON_TICKET, WO_TICKET]
};

export const ONE_CLUB = MembershipTypes.OneClub;
export const MASTERCARD_EXCLUSIVE = MembershipTypes.OneClubAdvantage;
export const NON_ONE_CLUB = 'Non-OneClub';
export const NON_MASTERCARD_EXCLUSIVE = 'Non-MasterCardExclusive';

export const displayConditionIsFulfilled = (params) => {
    const {
        bannerDisplaySettings,
        userMemberships,
        hasTicketsTO,
        hasTicketsWO
    } = params;
    return {
        [ONE_CLUB]: bannerDisplaySettings.includes(ONE_CLUB) && userMemberships &&
                    userMemberships.includes(ONE_CLUB),
        [NON_ONE_CLUB]: bannerDisplaySettings.includes(NON_ONE_CLUB) &&
                        (userMemberships === null || !userMemberships.includes(ONE_CLUB)),
        [MASTERCARD_EXCLUSIVE]: bannerDisplaySettings.includes(MASTERCARD_EXCLUSIVE) && userMemberships &&
                                userMemberships.includes(MASTERCARD_EXCLUSIVE),
        [NON_MASTERCARD_EXCLUSIVE]: bannerDisplaySettings.includes(NON_MASTERCARD_EXCLUSIVE) &&
                                    (userMemberships === null || !userMemberships.includes(MASTERCARD_EXCLUSIVE)),
        [TO_TICKET]: hasTicketsTO && bannerDisplaySettings.includes(TO_TICKET),
        [TO_NON_TICKET]: !hasTicketsTO && bannerDisplaySettings.includes(TO_NON_TICKET),
        [WO_TICKET]: hasTicketsWO && bannerDisplaySettings.includes(WO_TICKET),
        [WO_NON_TICKET]: !hasTicketsWO && bannerDisplaySettings.includes(WO_NON_TICKET),
    };
};
